import React, { useState } from 'react';
import styles from './TextArea.module.css';
import AutocompleteTextarea from '../AutoComplete/AutocompleteTextarea';

const TextArea = ({
  label,
  value,
  onChange,
  placeholder,
  showSuggestion,
  onSuggestionToggle,
}) => {
  const [userPrompt, setUserPrompt] = useState(value);

  const handleSuggestionChange = (newValue) => {
    setUserPrompt(newValue);
    onChange(newValue);
  };

  const handleSuggestion = (newValue) => {
    onSuggestionToggle(newValue);
  };

  return (
    <div className={styles.textAreaContainer}>
      {label && <label className={styles.label}>{label}</label>}
      <AutocompleteTextarea
        userPrompt={userPrompt}
        setUserPrompt={handleSuggestionChange}
        showSuggestion={showSuggestion}
        onSuggestionToggle={handleSuggestion}
      />
    </div>
  );
};

export default TextArea;
